var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseFileViewer',{attrs:{"name":_vm.name,"file-url":_vm.url},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }